// extracted by mini-css-extract-plugin
module.exports = {"widgetGenerator":"styles_widgetGenerator__Xs54x","widgetGeneratorLayout":"styles_widgetGeneratorLayout__UID8Z","widgetView":"styles_widgetView__uUPYK"};